import * as React from 'react';
import { render } from 'react-dom';

export interface IRenderRealtorBannerButtonParams {
  href: string;
  soprApiUrl: string;
}

export default function initialRealtorBannerButton() {
  // tslint:disable-next-line:no-any
  (window as any).renderRealtorBannerButton = (
    container: Element,
    { href, soprApiUrl }: IRenderRealtorBannerButtonParams,
  ) => {
    require.ensure(['./components/realtor_offer_button'], () => {
      const RealtorOfferButton = require('./components/realtor_offer_button').default;

      render(
        <RealtorOfferButton href={href} soprApiUrl={soprApiUrl}/>,
        container,
      );
    });
  };
}



// WEBPACK FOOTER //
// ./src/bundles/realtor_offer_button/index.tsx